import { getSessionEmail, normalizeEmail } from "@/lib/userSession";

export const OPTRA_ADMIN_EMAIL = "contact@optra-labs.com";
export const LOCALHOST_ACCESS_PREVIEW_KEY = "optra_localhost_access_preview";

export const isLocalhostRuntime = () => {
  if (typeof window === "undefined") return false;
  const host = String(window.location.hostname || "").toLowerCase();
  return host === "localhost" || host === "127.0.0.1";
};

export const isOptraAdminEmail = (email) => {
  return normalizeEmail(email || "") === OPTRA_ADMIN_EMAIL;
};

export const getLocalhostAccessPreviewMode = () => {
  if (typeof window === "undefined") return null;
  try {
    if (isLocalhostRuntime()) {
      const params = new URLSearchParams(window.location.search || "");
      const requested = String(
        params.get("preview") ||
        params.get("optra_preview") ||
        params.get("localhost_preview") ||
        ""
      ).trim().toLowerCase();
      if (requested === "admin" || requested === "customer") {
        window.sessionStorage.setItem(LOCALHOST_ACCESS_PREVIEW_KEY, requested);
        return requested;
      }
    }

    const raw = String(
      window.sessionStorage.getItem(LOCALHOST_ACCESS_PREVIEW_KEY) ||
      ""
    ).trim().toLowerCase();
    if (raw === "admin" || raw === "customer") return raw;

    return null;
  } catch {
    return null;
  }
};

export const setLocalhostAccessPreviewMode = (mode) => {
  if (typeof window === "undefined") return;
  try {
    if (!mode) {
      window.sessionStorage.removeItem(LOCALHOST_ACCESS_PREVIEW_KEY);
      return;
    }
    const normalized = String(mode).trim().toLowerCase();
    if (normalized === "admin" || normalized === "customer") {
      window.sessionStorage.setItem(LOCALHOST_ACCESS_PREVIEW_KEY, normalized);
    }
  } catch {
    // no-op
  }
};

export const hasAdminAccess = (emailOverride = null) => {
  const localhost = isLocalhostRuntime();
  const previewMode = getLocalhostAccessPreviewMode();
  if (localhost && previewMode === "customer") return false;
  if (localhost && previewMode === "admin") return true;

  let resolved = normalizeEmail(emailOverride || getSessionEmail() || "");
  if (!resolved && typeof window !== "undefined") {
    try {
      const clerkEmail =
        window.Clerk?.user?.primaryEmailAddress?.emailAddress ||
        window.Clerk?.session?.user?.primaryEmailAddress?.emailAddress ||
        window.Clerk?.session?.user?.emailAddresses?.[0]?.emailAddress ||
        "";
      resolved = normalizeEmail(clerkEmail);
    } catch {
      // no-op
    }
  }
  if (localhost) {
    return isOptraAdminEmail(resolved);
  }
  return isOptraAdminEmail(resolved);
};
